import { Injectable, OnDestroy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../../environments/environment';
import { StorageService } from '../storage.service';

@Injectable({
  providedIn: 'root'
})
export class UserSessionService implements OnDestroy {
  private readonly apiUrl = `${environment.apiUrl}/labase/user-sessions`;
  private heartbeatInterval: any;
  private readonly HEARTBEAT_INTERVAL_MS = 30000; // 30 secondes

  constructor(
    private http: HttpClient,
    private storageService: StorageService
  ) {}

  /**
   * Démarre l'envoi périodique du heartbeat
   * Appelé automatiquement lors de la connexion
   */
  startHeartbeat(): void {
    // Arrêter le heartbeat précédent s'il existe
    this.stopHeartbeat();

    // Vérifier si l'utilisateur est authentifié
    if (!this.storageService.isAuthenticated()) {
      return;
    }

    // Envoyer le premier heartbeat immédiatement
    this.sendHeartbeat();

    // Configurer l'intervalle pour les heartbeats suivants
    this.heartbeatInterval = setInterval(() => {
      if (this.storageService.isAuthenticated()) {
        this.sendHeartbeat();
      } else {
        this.stopHeartbeat();
      }
    }, this.HEARTBEAT_INTERVAL_MS);
  }

  /**
   * Arrête l'envoi du heartbeat
   * Appelé automatiquement lors de la déconnexion
   */
  stopHeartbeat(): void {
    if (this.heartbeatInterval) {
      clearInterval(this.heartbeatInterval);
      this.heartbeatInterval = null;
    }
  }

  /**
   * Envoie un heartbeat au serveur
   * Met à jour la dernière activité de l'utilisateur
   */
  private async sendHeartbeat(): Promise<void> {
    try {
      await firstValueFrom(
        this.http.post(`${this.apiUrl}/heartbeat`, {})
      );
    } catch (error) {
      // Ignorer les erreurs silencieusement pour ne pas perturber l'UX
      // Le serveur retourne 204 No Content en cas de succès
    }
  }

  /**
   * Récupère le nombre d'utilisateurs actuellement actifs
   */
  getActiveUsersCount(): Promise<{ activeCount: number }> {
    return firstValueFrom(
      this.http.get<{ activeCount: number }>(`${this.apiUrl}/active-count`)
    );
  }

  ngOnDestroy(): void {
    this.stopHeartbeat();
  }
}
